import axios from "axios";
import baseURL from "../config/api";

export const post_ForgotPassword = (emailAddress: string) => {
    return axios({
        url: `${baseURL}AuthUser/ForgotPassword?userEmail=${encodeURIComponent(emailAddress)}`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        withCredentials: false,
        data: {}
    }).then(response => response.data);
}